import {useCallback, useEffect, useState} from "react";
import {useContract} from "./useContract";
import {ABI_LAUNCHPAD_POOL} from "../utils/abis";
import {isEqualString} from "../utils";
import {useWeb3React} from "@web3-react/core";
import {DialogType, useDialog} from "../context/DialogContext";
import {BigNumber, constants} from "ethers";

export default function useIGOClaim(poolAddress?: string|null) {
    const [canClaim, setCanClaim] = useState(false)
    const [claimAmount, setClaimAmount] = useState<BigNumber>(constants.Zero)
    const contract = useContract(poolAddress, ABI_LAUNCHPAD_POOL)
    const {account} = useWeb3React()
    const {open} = useDialog()
    useEffect(() => {
        if (contract) {
            contract.canClaim(account).then(setCanClaim)
            contract._unlockBalanceRecords(account).then(setClaimAmount)
            const listener = (address: string) => {
                if (isEqualString(address, account)) {
                    contract.canClaim().then(setCanClaim)
                    contract._unlockBalanceRecords(account).then(setClaimAmount)
                }
            }
            contract.on('Release', listener)
            return () => {
                contract.removeListener('Release', listener)
            }
        }
    }, [contract, account])
    const handleClaim = useCallback(async () => {
        if (contract) {
            try {
                open(DialogType.Waiting, {title: 'Waiting for confirm Claim.'})
                const operation = await contract.claim()
                open(DialogType.Waiting, {title: 'Waiting for confirmation.'})
                await operation.wait()
                open(DialogType.Success, {title: 'Success!'})
                return true
            } catch (e:any) {
                console.log('error:claim', e)
                open(DialogType.Error, {title: 'Claim error!', desc: e.message || e.data?.message})
                return false
            }
        }
    }, [contract, open])
    return {canClaim, handleClaim, claimAmount}
}